var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#DBF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8037 7.20455C18.0001 7.00812 18.2333 6.8523 18.49 6.74599C18.7467 6.63968 19.0217 6.58496 19.2995 6.58496C19.5773 6.58496 19.8524 6.63968 20.1091 6.74599C20.3657 6.8523 20.5989 7.00812 20.7954 7.20455C20.9918 7.40099 21.1476 7.63419 21.2539 7.89085C21.3602 8.1475 21.415 8.42259 21.415 8.70039C21.415 8.97819 21.3602 9.25327 21.2539 9.50993C21.1476 9.76658 20.9918 9.99978 20.7954 10.1962L10.6985 20.2931L6.58496 21.415L7.70684 17.3014L17.8037 7.20455Z",
    stroke: "#006982",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.3e5ce68f132461a83d1f18aef2d67ad9.svg";
export { ForwardRef as ReactComponent };